$(document).ready(function () {
    const videoEl = document.querySelector('.eg-video video');
    $('.eg-seeInAction').on('click', function () {
      document.body.classList.add('eg-show-video');
      
      if (videoEl) {
        videoEl.play();
      } else {
        console.error("Video element not found");
      }
    });
        $('.eg-popup-overlay, .eg-popup-content').on('click', function (event) {
          if (
            event.target.classList.contains('eg-popup-overlay') ||
            event.target.classList.contains('eg-popup-close') ||
            event.target.classList.contains('eg-popup-content')
          ) {
            document.body.classList.remove('eg-show-video');
            if (videoEl) {
              videoEl.pause();
              videoEl.currentTime = 0;
            }
          }
        });
            $('.eg-popup-close').on('click', function () {
              $('.eg-popup-overlay').trigger('click'); // Simulates a click on the overlay
            });
  });
// $('.eg-popup-overlay, .eg-popup-content', 'click', function (event) {
//   if (
//     event.target.classList.contains('eg-popup-overlay') ||
//     event.target.classList.contains('eg-popup-close') ||
//     event.target.classList.contains('eg-popup-content')
//   ) {
//     document.body.classList.remove('eg-show-video');
//     if (videoEl) {
//       videoEl.pause();
//       videoEl.currentTime = 0;
//     }
//   }
// });
// $('.eg-popup-close', 'click', function() {
//   document.querySelector('.eg-popup-overlay').click();
// });
// (function () {
//     try {
//       /* main variables */
//       var debug = 0;
//       var variation_name = "";
//       var $;
//       /* all Pure helper functions */
//       function waitForElement(selector, trigger, delayInterval, delayTimeout) {
//         var interval = setInterval(function () {
//           if (
//             document &&
//             document.querySelector(selector) &&
//             document.querySelectorAll(selector).length > 0
//           ) {
//             clearInterval(interval);
//             trigger();
//           }
//         }, delayInterval);
//         setTimeout(function () {
//           clearInterval(interval);
//         }, delayTimeout);
//       }
//       function live(selector, event, callback, context) {
//         function addEvent(el, type, handler) {
//           if (el.attachEvent) el.attachEvent('on' + type, handler);
//           else el.addEventListener(type, handler);
//         }
//         this.Element &&
//           (function (ElementPrototype) {
//             ElementPrototype.matches =
//               ElementPrototype.matches ||
//               ElementPrototype.matchesSelector ||
//               ElementPrototype.webkitMatchesSelector ||
//               ElementPrototype.msMatchesSelector ||
//               function (selector) {
//                 var node = this,
//                   nodes = (node.parentNode || node.document).querySelectorAll(selector),
//                   i = -1;
//                 while (nodes[++i] && nodes[i] != node);
//                 return !!nodes[i];
//               };
//           })(Element.prototype);
//         function live(selector, event, callback, context) {
//           addEvent(context || document, event, function (e) {
//             var found,
//               el = e.target || e.srcElement;
//             while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
//             if (found) callback.call(el, e);
//           });
//         }
//         live(selector, event, callback, context);
//       };
//         // var videoPopup = `
//         //   <div class="eg-video-popup">
//         //     <div class="eg-popup-overlay"></div>
//         //     <div class="eg-popup-content">
//         //       <div class="eg-video">
//         //       <div class="eg-popup-close">
//         //           <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
//         //             <path d="M15.9834 15.2695L23.249 7.98926C23.4443 7.79395 23.6396 7.69629 23.835 7.69629C23.9717 7.69629 24.0791 7.74512 24.1572 7.84277C24.2451 7.94043 24.2891 8.05762 24.2891 8.19434C24.2891 8.27246 24.2695 8.36035 24.2305 8.45801C24.1914 8.55566 24.1279 8.64844 24.04 8.73633L16.7451 15.9873L24.1719 22.9014C24.2988 23.0186 24.3867 23.1406 24.4355 23.2676C24.4941 23.3848 24.5234 23.4922 24.5234 23.5898C24.5234 23.707 24.4844 23.8047 24.4062 23.8828C24.3379 23.9609 24.2451 24 24.1279 24C23.9131 24 23.6836 23.8828 23.4395 23.6484L15.9834 16.7051L8.52734 23.6631C8.38086 23.7998 8.25391 23.8926 8.14648 23.9414C8.03906 23.9805 7.93652 24 7.83887 24C7.71191 24 7.60938 23.9658 7.53125 23.8975C7.46289 23.8193 7.42871 23.7217 7.42871 23.6045C7.42871 23.3799 7.55078 23.1504 7.79492 22.916L15.2217 15.9873L7.92676 8.73633C7.75098 8.56055 7.66309 8.37988 7.66309 8.19434C7.66309 8.05762 7.70703 7.94043 7.79492 7.84277C7.88281 7.74512 7.99512 7.69629 8.13184 7.69629C8.32715 7.69629 8.52246 7.79395 8.71777 7.98926L15.9834 15.2695Z" fill="black" fill-opacity="0.8"></path>
//         //           </svg>
//         //         </div>
//         //         <video src="https://cdn.shopify.com/videos/c/o/v/90544b0238f541ecb08feb84507eb523.mp4" playsinline>
//         //       </div>
//         //     </div>
//         //   </div>`;
//       /* Variation Init */
//       function init() {
//         document.body.classList.add('AB0041');
//         const destEl = document.querySelector('.page-content--product .product-single__sticky > div');
//         if(destEl && !document.querySelector('.eg-seeInAction')) {
//           destEl.insertAdjacentHTML('beforeend', seeInAction);
//         }
//         if(!document.querySelector('.eg-video-popup')) {
//           document.body.insertAdjacentHTML('beforeend', videoPopup)
//         }
//         const videoEl = document.querySelector('.eg-video video');
//         live('.eg-seeInAction', 'click', function () {
//           document.body.classList.add('eg-show-video');
//           if (videoEl) {
//             videoEl.play();
//           }
//         });
//         live('.eg-popup-overlay, .eg-popup-content', 'click', function (event) {
//           if (
//             event.target.classList.contains('eg-popup-overlay') ||
//             event.target.classList.contains('eg-popup-close') ||
//             event.target.classList.contains('eg-popup-content')
//           ) {
//             document.body.classList.remove('eg-show-video');
//             if (videoEl) {
//               videoEl.pause();
//               videoEl.currentTime = 0;
//             }
//           }
//         });
//         live('.eg-popup-close', 'click', function() {
//           document.querySelector('.eg-popup-overlay').click();
//         });
//       }
//       /* Initialize variation */
//     //   if (window.location.pathname === '/collections/indestructible-smartwatch-models/products/njord-watch-pro') {
//         waitForElement('.page-content--product .product-single__sticky > div', init, 50, 15000);
//     //   }
//     } catch (e) {
//       if (debug) console.log(e, "error in Test" + variation_name);
//     }
//   })();